import { atom, atomFamily } from 'recoil';

import { QueryStatus } from 'react-query';

import { GiftChoiceUnitData, GiftChoiceUnitList } from './giftChoiceUnit.interface';

// GiftChoiceUnit 목록
export const giftChoiceUnitListStatusAtom = atom<QueryStatus>({
  key: 'giftChoiceUnitListStatusAtom',
  default: 'idle',
});

export const giftChoiceUnitListDataAtom = atom<GiftChoiceUnitList>({
  key: 'giftChoiceUnitListDataAtom',
  default: [],
});

// GiftChoiceUnit 단건
export const giftChoiceUnitStatusAtomFamily = atomFamily<QueryStatus, string>({
  key: 'giftChoiceUnitStatusAtomFamily',
  default: 'idle',
});

export const giftChoiceUnitDataAtomFamily = atomFamily<GiftChoiceUnitData | null, string>(
  {
    key: 'giftChoiceUnitDataAtomFamily',
    default: null,
  },
);
